import fetch from "auth/FetchInterceptor";
import requestCacheService from "./RequestCacheService";

const grupoSeguroService = {};

grupoSeguroService.get = async function (params = {}) {
	const {
		page = 0,
		pageSize = 5,
		search = "",
		orderBy = "id",
		orderDirection = "asc",
		filters = {},
	} = params;

	const queryParams = {
		page,
		pageSize,
		search,
		orderBy,
		orderDirection,
		filters,
	};

	return fetch({
		url: "/v1/rest/grupo-seguro",
		method: "get",
		params: queryParams,
		headers: { is_paginated: true },
	});
};

grupoSeguroService.getAll = async function () {
	return requestCacheService.cacheRequest(
		"lista_grupos_seguro",
		() => {
			return fetch({
				url: "/v1/rest/grupo-seguro",
				method: "get",
			});
		},
		300,
	);
};

grupoSeguroService.prepararDados = async function (values) {
	// Extrair os campos de arquivo
	const { certificate, privateKey, ...restValues } = values;

	// Se não houver arquivos, retorna os valores normais (como JSON)
	if (!certificate && !privateKey) {
		return values;
	}

	// Cria um FormData para enviar os arquivos
	const formData = new FormData();

	// Adiciona os arquivos, se existirem
	if (certificate && certificate.length > 0) {
		const file = certificate[0].originFileObj;
		if (file) {
			formData.append("certificate", file);
		}
	}

	if (privateKey && privateKey.length > 0) {
		const file = privateKey[0].originFileObj;
		if (file) {
			formData.append("privateKey", file);
		}
	}

	// Adiciona os outros dados como um único campo JSON
	// Remover os campos de arquivo para evitar enviar duas vezes
	const dadosParaEnviar = { ...restValues };
	delete dadosParaEnviar.certificate;
	delete dadosParaEnviar.privateKey;

	const jsonData = JSON.stringify(dadosParaEnviar);
	formData.append("jsonData", jsonData);

	// Array.from(formData.entries()).forEach(([key, value]) => {
	// 	console.log(
	// 		`${key}: ${typeof value === "string" ? value : "[Arquivo]"}`,
	// 	);
	// });

	return formData;
};

grupoSeguroService.post = async function (values) {
	await requestCacheService.limparCache("lista_grupos_seguro");

	// Se values é FormData, não precisa de headers especiais
	if (values instanceof FormData) {
		return fetch({
			url: "/v1/rest/grupo-seguro",
			method: "post",
			data: values,
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
	}

	return fetch({
		url: "/v1/rest/grupo-seguro",
		method: "post",
		data: values,
	});
};

grupoSeguroService.put = async function (values, id) {
	await requestCacheService.limparCache("lista_grupos_seguro");

	// Se values é FormData, não precisa de headers especiais
	if (values instanceof FormData) {
		return fetch({
			url: "/v1/rest/grupo-seguro/" + id,
			method: "put",
			data: values,
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
	}

	return fetch({
		url: "/v1/rest/grupo-seguro/" + id,
		method: "put",
		data: values,
	});
};

grupoSeguroService.getById = async (id) => {
	return fetch({
		url: `/v1/rest/grupo-seguro/${id}`,
		method: "get",
	});
};

grupoSeguroService.delete = async (id) => {
	return fetch({
		url: `/v1/rest/grupo-seguro/${id}`,
		method: "delete",
	});
};

export default grupoSeguroService;
